import { Injectable } from '@angular/core';
import { EnvDomainVariables } from './env.service';
@Injectable({
  providedIn: 'root',
})
export class EnvMagellanQaService {
  getDomainInfo(): EnvDomainVariables {
    return {
      _enableErrorLogging: true,
      _enableRefreshToken: false,
      isMagellan: '1',
      _env: 'magellan-qa',
      _apiUrl: 'https://qa2-api.p-cis.com/api/',
      _production: true,
      _redirectUri: 'https://qa2-login.p-cis.com/',
      _responseType: 'token id_token',
      _issuer:
        'https://magellanqaadb2c.b2clogin.com/a3efeb64-6486-4cb3-91f7-d76e3d4f8815/v2.0/',
      _strictDiscoveryDocumentValidation: false,
      _tokenEndpoint:
        'https://magellanqaadb2c.b2clogin.com.b2clogin.com/magellanqaadb2c.onmicrosoft.com/oauth2/v2.0/token?p=b2c_1_signin',
      _loginUrl:
        'https://magellanqaadb2c.b2clogin.com/magellanqaadb2c.onmicrosoft.com/oauth2/v2.0/token?p=B2C_1_Signin',
      _clientId: 'd4564c9f-eda6-4ee3-8e1f-29ef8c7a8b52',
      _scope:
        'openid profile https://magellanqaadb2c.onmicrosoft.com/api/magellan.read',
      _skipIssuerCheck: true,
      _clearHashAfterLogin: true,
      _oidc: true,
      _logoutUrl:
        'https://magellanqaadb2c.b2clogin.com/magellanqaadb2c.onmicrosoft.com/B2C_1A_signin_signup_frp/oauth2/v2.0/logout?post_logout_redirect_uri=https://qa2-login.p-cis.com/',
      _signInURL:
        'https://magellanqaadb2c.b2clogin.com/magellanqaadb2c.onmicrosoft.com/v2.0/.well-known/openid-configuration?p=B2C_1A_signin_signup_frp',
      _signInURLSSO:
        'https://magellanqaadb2c.b2clogin.com/magellanqaadb2c.onmicrosoft.com/v2.0/.well-known/openid-configuration?p=B2C_1A_SIGNIN_SIGNUP_FRP_SSO',
      _adb2cTenantUrl:
        'https://magellanqaadb2c.b2clogin.com/magellanqaadb2c.onmicrosoft.com/oauth2/v2.0/',
      _magicLink:
        'https://opeekab2cdev.b2clogin.com/opeekab2cdev.onmicrosoft.com/v2.0/.well-known/openid-configuration?p=B2C_1A_SIGNIN_WITH_EMAIL',
      _authEndpoint:'https://magellanqaadb2c.b2clogin.com/magellanqaadb2c.onmicrosoft.com/B2C_1A_signin_signup_frp/oauth2/v2.0/authorize',
      _magicLinkScope : 'https://magellanqaadb2c.b2clogin.com/magellanqaadb2c.onmicrosoft.com/B2C_1A_SIGNIN_WITH_EMAIL/oauth2/v2.0/authorize',
      _launchDarklyClientId: '69120006711aa209b78d9aaf',
      _intercomAppId: 'bqgvwybf'
    };
  }
}
